import delay from 'delay';
import { accessToken, loggedIn } from 'src/store/state';
import { boot } from 'quasar/wrappers';

export default boot(({ router }) => {
  router.beforeEach(async (to, from, next) => {
    while (accessToken.value === undefined) await delay(16);

    if (!loggedIn.value && to.path !== '/') return next({ path: '/' });
    if (loggedIn.value && to.path === '/') return next({ path: '/teclado' });

    return next();
  });
  router.afterEach((to, from) => {
    if (from.path === '/') {
      to.meta.transitionName = 'slide-next';
    } else if (to.path === '/') {
      to.meta.transitionName = 'slide-prev';
    } else if (to.path === '/minha-conta') {
      to.meta.transitionName = 'slide-next';
    } else if (from.path === '/minha-conta') {
      to.meta.transitionName = 'slide-prev';
    }
    // gtag('event', 'screen_view', { screen_name: to.name });
  });
});
